import {
 bexHttpClient
} from '../../clients';

export interface ActionFlowConfigData {
    org_id: string;
    app_id: string;
    action_flow_id?: string;
    name: string;
    description?: string;
    steps: Array<{
        id: string;
        type: 'FETCH' | 'API_CALL' | 'MUTATE';
        name: string;
        config: Record<string, any>;
    }>;
    [key: string]: any;
}

export interface ActionFlowConfigResponse extends ActionFlowConfigData {
    action_flow_id: string;
    created_at?: string;
    updated_at?: string | null;
    createdBy?: string;
    updatedBy?: string | null;
}

class ActionFlowConfigService {
    private baseURL: string;

    constructor(baseURL = '/redis/action-flow-configs') {
        this.baseURL = baseURL;
    }

    async createActionFlowConfig(data: ActionFlowConfigData): Promise<ActionFlowConfigResponse> {
        const response = await bexHttpClient.post<ActionFlowConfigResponse>(this.baseURL, data);
        return response.data;
    }

    async listActionFlowConfigs(orgId: string, appId: string): Promise<ActionFlowConfigResponse[]> {
        const response = await bexHttpClient.get(
            `${this.baseURL}?org_id=${orgId}&app_id=${appId}`
        );

        if (Array.isArray(response.data)) {
            return response.data;
        }
        if (response.data?.status === 'success' && Array.isArray(response.data.data)) {
            return response.data.data;
        }
        return [];
    }

    async getActionFlowConfig(orgId: string, appId: string, actionFlowId: string): Promise<ActionFlowConfigResponse> {
        const response = await bexHttpClient.get<ActionFlowConfigResponse>(
            `${this.baseURL}/${actionFlowId}?org_id=${orgId}&app_id=${appId}`
        );
        return response.data;
    }

    async updateActionFlowConfig(actionFlowId: string, data: ActionFlowConfigData): Promise<ActionFlowConfigResponse> {
        const response = await bexHttpClient.patch<ActionFlowConfigResponse>(
            `${this.baseURL}/${actionFlowId}`,
            data
        );
        return response.data;
    }

    async deleteActionFlowConfig(orgId: string, appId: string, actionFlowId: string): Promise<{ success: boolean }> {
        const response = await bexHttpClient.delete<{ success: boolean }>(
            `${this.baseURL}/${actionFlowId}?org_id=${orgId}&app_id=${appId}`
        );
        return response.data;
    }
}

const actionFlowConfigService = new ActionFlowConfigService();
export { actionFlowConfigService };
